import { Card, alpha } from "@mui/material"

const ProfessionalCard = ({ children, elevation = 0, sx = {}, gradient = false, hover = true, ...props }) => {
  return (
    <Card
      elevation={elevation}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: alpha("#96D232", 0.2),
        background: gradient
          ? "linear-gradient(135deg, rgba(150, 210, 50, 0.05) 0%, rgba(255, 255, 255, 0.95) 100%)"
          : "#fff",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        ...(hover && {
          "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.12)",
            borderColor: alpha("#96D232", 0.4),
          },
        }),
        ...sx,
      }}
      {...props}
    >
      {children}
    </Card>
  )
}

export default ProfessionalCard
